var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonMonoxideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9297 6.8667e-05C8.06824 6.8667e-05 5.22369 1.20747 3.20053 3.28223C1.17737 5.35698 0 8.27407 0 11.2085C0 14.143 1.17737 17.0601 3.20053 19.1349C5.22369 21.2096 8.06824 22.417 10.9297 22.417C12.5298 22.4122 14.1265 22.0414 15.573 21.3397V21.3401C16.0412 21.1128 16.5996 21.2332 16.9391 21.6344L18.5988 23.5912C18.9327 23.9851 18.9755 24.5573 18.704 24.9989C17.8808 26.3397 17.4337 27.9198 17.4299 29.5044V29.5058V29.5073C17.4303 31.7304 18.3231 33.94 19.856 35.512C21.3894 37.0844 23.5455 38 25.7143 38C27.8835 38 30.0387 37.0849 31.5725 35.512C33.1064 33.939 34 31.7289 34 29.5043C34 27.2798 33.1077 25.0683 31.5738 23.4953C30.0405 21.9228 27.8853 21.0078 25.717 21.0073H25.7142C24.5246 21.0106 23.3365 21.2818 22.2572 21.7947H22.2568C21.7904 22.0162 21.2372 21.8949 20.9 21.4966L19.4432 19.7773H19.4428C19.0755 19.3433 19.0647 18.7014 19.4179 18.2549C20.9794 16.2812 21.8567 13.7494 21.8599 11.2075C21.8594 8.27351 20.6821 5.35692 18.6589 3.28265C16.6357 1.2074 13.7912 6.8667e-05 10.9297 6.8667e-05Z",
    fill: "#20E89C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonMonoxideIcon);
export default __webpack_public_path__ + "static/media/carbonMonoxideIcon.ed2096cf94b8ec8705635e85b8b28b38.svg";
export { ForwardRef as ReactComponent };